export const IDS = {
  COMMON: {
    DIALOG_OK: 'oc-common__dialog-ok',
    DIALOG_CLOSE: 'oc-common__dialog-close',
    IMAGE_MANAGER_EDIT: 'oc-common__image-manager-edit',
    IMAGE_MANAGER_UPDATE: 'oc-common__image-manager-update',
    IMAGE_MANAGER_REMOVE: 'oc-common__image-manager-remove',
    ACTION_CONFIRMATION_SUBMIT: 'oc-common__action-confirmation-submit',
    ACTION_CONFIRMATION_CANCEL: 'oc-common__action-confirmation-cancel',
  },
  NAV_BAR: {
    COMMUNITIES: 'oc-navbar__communities',
    HEALTH_BOARD: 'oc-navbar__healthboard',
    HOME: 'oc-navbar__home',
    MESSAGES: 'oc-navbar__messages',
    CIRCLES: 'oc-navbar__my-circles',
    DASHBOARD: 'oc-navbar__dashboard',
    PROFILE: 'oc-navbar__profile',
    LOG_OUT: 'oc-navbar__logout',
    APP_NOTIFICATIONS_LINK: 'oc-navbar__app-notifications-link',
    OPEN_JOIN_POPUP: 'oc-navbar__open-join-popup',
    JOIN_CIRCLE_MENU_ITEM: 'oc-navbar__join-circle-menu-item',
    ADD_DEPENDENT_MENU_ITEM: 'oc-navbar__add-dependent-menu-item',
    ADD_PATIENT_MENU_ITEM: 'oc-navbar__add-patient-menu-item',
  },
  COMMUNITIES_BAR: {
    DISCOVER: 'oc-communities-bar__discover',
    MY_COMMUNITIES: 'oc-communities-bar__my-communities',
    ACTIVITIES: 'oc-communities-bar__activities',
    REPORTS: 'oc-communities-bar__reports',
  },
  MY_COMMUNITIES_TABS: {
    ALL: 'oc-my-communities-tab__all',
    I_AM_MODERATOR: 'oc-my-communities-tab__iam-moderator',
    REQUESTED: 'oc-my-communities-tab__requested',
  },
  ACTIVITIES_TABS: {
    NOTIFICATIONS: 'oc-activities-tab__notifications',
    JOIN_REQUESTS: 'oc-activities-tab__join-requests',
    MEMBER_INVITATIONS: 'oc-activities-tab__invitations',
  },
  ACTIVITIES: {
    INVITATION_ACCEPT_BTN: 'oc-activities__invitation-accept-btn',
    INVITATION_DECLINE_BTN: 'oc-activities__invitation-decline-btn',
    JOIN_REQUEST_ACCEPT_BTN: 'oc-activities__join-request-accept-btn',
    JOIN_REQUEST_DECLINE_BTN: 'oc-activities__join-request-decline-btn',
  },
  REPORTS_TABS: {
    UNRESOLVED: 'oc-reports-tab__unresolved',
    RESOLVED: 'oc-reports-tab__resolved',
  },
  SEARCH_TABS: {
    PEOPLE: 'oc-search-tab__people',
    TEAMS: 'oc-search-tab__teams',
    PROVIDER: 'oc-search-tab__provider',
  },
  REPORTS: {
    SEE_DETAILS_BTN: 'oc-reports__see-details-btn',
    RESOLVE_BTN: 'oc-reports__resolve-btn',
    REMOVE_AUTHOR_OPTION: 'oc-reports__remove-author-option',
    DESTROY_REPORTABLE_OPTION: 'oc-reports__destroy-reportable-option',
    SEND_MESSAGE_OPTION: 'oc-reports__send-message-option',
  },
  COMMUNITY: {
    MENU_TRIGGER: 'oc-community__menu-trigger',
    ACCEPT_INVITATION_BTN: 'oc-community__accept-invite-btn',
    DECLINE_INVITATION_BTN: 'oc-community__decline-invite-btn',
    CREATE_POST_BTN: 'oc-community__create-post-btn',
    JOIN_BTN: 'oc-community__join-btn',
    SEE_ALL_MEMBERS: 'oc-community__see-all-members',
    SEE_ALL_MODERATORS: 'oc-community__see-all-moderators',
    MEMBER_MENU_TRIGGER: 'oc-community__member-menu-trigger',
    MENU_EDIT: 'oc-community__menu-edit',
    MENU_LEAVE: 'oc-community__menu-leave',
    MENU_CANCEL: 'oc-community__menu-cancel',
    EDIT_LOGO: 'oc-community__edit-logo',
    EDIT_BANNER: 'oc-community__edit-banner',
  },
  MENU: {
    EDIT_POST: 'oc-menu__edit-post',
    REMOVE_POST: 'oc-menu__remove-post',
    REMOVE_COMMENT: 'oc-menu__remove-comment',
    EDIT_COMMENT: 'oc-menu__edit-comment',
    SEND_MESSAGE: 'oc-menu__send-message',
    REPORT: 'oc-menu__report',
    INVITE_TO_COMMUNITY: 'oc-menu__invite-to-community',
    SHARE_LINK: 'oc-menu__share-link',
    LEAVE_COMMUNITY: 'oc-menu__leave-community',
    REMOVE_MEMBER: 'oc-menu__remove-member',
    EDIT_COMMUNITY: 'oc-menu__edit-community',
    REMOVE_FROM_COMMUNITY: 'oc-menu__remove-from-community',
    CHANGE_ROLE: 'oc-menu__change-role',
    UNASSIGN: 'oc-menu__unassign',
  },
  POST: {
    MENU_TRIGGER: 'oc-post__menu-trigger',
    ADD_COMMENT: 'oc-post__add-comment-btn',
    POST_COMMENT: 'oc-post__post-comment-btn',
    POST_TEXT_AREA: 'oc-post__text-area',
    COMMENT_ICON: 'oc-post__comment-icon',
    LIKE_ICON: 'oc-post__like-icon',
    REPLY_COMMENT_BTN: 'oc-post__reply-comment-btn',
    REPLY_TEXT_AREA: 'oc-post__reply-text-area',
    SEND_REPLY_COMMENT_BTN: 'oc-post__send-reply-comment-btn',
    REPLY_COMMENT_MENU_TRIGGER: 'oc-post__reply-comment-menu-trigger',
  },
  CHAT_SEND_MESSAGE: {
    IMPORTANT: 'oc-chat-send-message__important',
    IMPORTANT_SELECTED: 'oc-chat-send-message__important-selected',
    ATTACH_ICON_MENU: 'oc-chat-send-message__attach-icon-menu',
    ATTACH_FILE: 'oc-chat-send-message__attach-file',
    ATTACH_ANSWER_FORM: 'oc-chat-send-message__attach-answer-form',
    ATTACH_SURVEY: 'oc-chat-send-message__attach-survey',
    UNBLOCK_USER: 'oc-chat-send-message__unblock-user',
    SEND_MESSAGE: 'oc-chat-send-message__send-message',
  },
  CHAT_FILTER: {
    MENU: 'oc-chat-filter__menu',
    ITEM: 'oc-chat-filter__item',
    ITEM_ALL: 'oc-chat-filter__item-all',
    ITEM_PATIENT: 'oc-chat-filter__item-patient',
    ITEM_PROVIDER: 'oc-chat-filter__item-provider',
    ITEM_SOCIAL: 'oc-chat-filter__item-social',
    SUB_FILTER: 'oc-chat-filter__sub-filter',
  },
  CHAT_CONTEXT: {
    MENU: 'oc-chat-context__menu',
    CIRCLE_OF_CARE: 'oc-chat-context__circle-of-care',
    SURVEYS: 'oc-chat-context__surveys',
    PROGRAMS: 'oc-chat-context__programs',
    HIDE_DRAWER: 'oc-chat-context__hide-drawer',
    START_CONVERSATION: 'oc-chat-context__start-conversation',
  },
  APP_NOTIFICATIONS: {
    TODO_TAB: 'oc-app-notifications__todo-tab',
    COMPLETED_TAB: 'oc-app-notifications__completed-tab',
    REQUEST_CONFIRM: 'oc-app-notifications__request-confirm',
    REQUEST_DECLINE: 'oc-app-notifications__request-decline',
  },
  DASHBOARD: {
    TABLE_MENU_TRIGGER: 'oc-dashboard__table-menu-trigger',
    TABLE_MENU_MOVE_TO_FRONT: 'oc-dashboard__table-menu-move-to-front',
    TABLE_MENU_CHANGE_STATUS: 'oc-dashboard__table-menu-change-status',
    TABLE_MENU_ASSIGN_ROOM: 'oc-dashboard__table-menu-assign-room',
    TABLE_MENU_CHANGE_PAYMENT_STATUS:
      'oc-dashboard__table-menu-change-payment-status',
    TABLE_MENU_EDIT_PAYMENT_AMOUNT:
      'oc-dashboard__table-menu-edit-payment-amount',
  },
  DEPENDENT_ROLES: {
    PROXY: 'oc-dependent-roles__proxy',
    PARENT: 'oc-dependent-roles__parent',
    GUARDIAN: 'oc-dependent-roles__guardian',
  },
  ADD_DEPENDENT: {
    NEXT: 'oc-add-dependent__next',
  },
  FORM_FIELDS: {
    EMAIL: 'oc-form-fields__email',
    PHONE_NUMBER: 'oc-form-fields__phone-number',
    HOME_PHONE: 'oc-form-fields__home-phone-number',
    FIRST_NAME: 'oc-form-fields__first-name',
    LAST_NAME: 'oc-form-fields__last-name',
    MIDDLE_NAME: 'oc-form-fields__middle-name',
    GENDER: 'oc-form-fields__gender',
    DOB: {
      DAY: 'oc-form-fields__dob-day',
      MONTH: 'oc-form-fields__dob-month',
      YEAR: 'oc-form-fields__dob-year',
    },
    NAME_SUFFIX: 'oc-form-fields__name-suffix',
    REASON_TYPE: 'oc-form-fields__reason-type',
    REASON_NOTE: 'oc-form-fields__reason-note',
    REASON_VISIT: 'oc-form-fields__reason-visit',
    MRNS: 'oc-form-fields__mrn',
    SSN: 'oc-form-fields__ssn',
    ADDRESS_1: 'oc-form-fields__address1',
    ADDRESS_2: 'oc-form-fields__address2',
    CITY: 'oc-form-fields__city',
    STATE: 'oc-form-fields__state',
    IS_HOME_LOCATION_DIFFERENT: 'oc-form-fields__is-home-location-different',
    COUNTRY: 'oc-form-fields__country',
    POSTAL_CODE: 'oc-form-fields__postal-code',
    RELATION: 'oc-form-fields__relation',
    AVATAR: 'oc-form-fields__avatar',
    AGE: 'oc-form-fields__age',
    ROLE: 'oc-form-fields__role',
    CARE_ROLE: 'oc-form-fields__care-role',
    RELATIONSHIP: 'oc-form-fields__relationship',
    TERMS_AND_CONDITIONS: 'oc-form-fields__terms-and-conditions',
    LOGIN: 'oc-form-fields__login',
    LOCATION: 'oc-form-fields__location',
    SERVICE: 'oc-form-fields__service',
    PROVIDER: 'oc-form-fields__provider',
    ROOM: 'oc-form-fields__room',
    PAYMENT_STATUS: 'oc-form-fields__payment-status',
    CATEGORY: 'oc-form-fields__category',
    SUB_CATEGORY: 'oc-form-fields__sub-category',
    DOCUMENTS: 'oc-form-fields__documents',
    SURVEYS: 'oc-form-fields__surveys',
    CONSENTS: 'oc-form-fields__consents',
    NOTIFICATION_CONSENTS: 'oc-form-fields__notification-consents',
    MEMBER_ID: 'oc-form-fields__member-id',
    GROUP_NUMBER: 'oc-form-fields__group-number',
    PRESCRIPTIONS: 'oc-form-fields__prescriptions',
  },
  APPOINTMENT_FORM: {
    ROOT: 'oc-appointment-form__root',
    SUBMIT_PATIENT_FORM: 'oc-appointment-form__submit-patient-form',
    SUBMIT_DOCUMENTS_FORM: 'oc-appointment-form__submit-doc-form',
    SUBMIT_REASON_TYPE: 'oc-appointment-form__submit-reason-type',
    OTHER_REASON_TYPE: 'oc-appointment-form__other-reason-type',
  },
  APPOINTMENT_LIST: {
    TAB_UPCOMING: 'oc-appointment-list__tab-upcoming',
    TAB_HISTORY: 'oc-appointment-list__tab-history',
  },
  PATIENT_PORTAL: {
    TAB_MEDICATIONS: 'oc-patient-portal__tab-medications',
    TAB_IMMUNIZATIONS: 'oc-patient-portal__tab-immunizations',
    TAB_LAB_TEST_RESULT: 'oc-patient-portal__tab-lab-test-results',
    TAB_ALLERGIES: 'oc-patient-portal__tab-allergies',
    TAB_CONDITIONS: 'oc-patient-portal__tab-conditions',
    TAB_SOCIAL_HISTORY: 'oc-patient-portal__tab-social-history',
    TAB_FAMILY_HISTORY: 'oc-patient-portal__tab-family-history',
    ADD_WEIGHT_FORM: {
      DATE: 'oc-patient-portal__add-weight-form-date',
      TIME: 'oc-patient-portal__add-weight-form-time',
      WEIGHT: 'oc-patient-portal__add-weight-form-weight',
      ADD_BUTTON: 'oc-patient-portal__add-weight-form-add-button',
    },
    ADD_HEIGHT_FORM: {
      DATE: 'oc-patient-portal__add-height-form-date',
      TIME: 'oc-patient-portal__add-height-form-time',
      FEET: 'oc-patient-portal__add-height-form-feet',
      INCH: 'oc-patient-portal__add-height-form-inch',
      ADD_BUTTON: 'oc-patient-portal__add-height-form-add-button',
    },
    ADD_BODY_INFO_FORM: {
      DATE: 'oc-patient-portal__add-body-form-date',
      TIME: 'oc-patient-portal__add-body-form-time',
      FEET: 'oc-patient-portal__add-body-form-feet',
      INCH: 'oc-patient-portal__add-body-form-inch',
      WEIGHT: 'oc-patient-portal__add-body-form-weight',
      ADD_BUTTON: 'oc-patient-portal__add-body-form-add-button',
    },
    TAB_HEALTH_RECORD: {
      VIEW_RECORD: 'oc-patient-portal__health-record-view',
      SHARE_RECORD: 'oc-patient-portal__health-record-share',
      DOWNLOAD_RECORD: 'oc-patient-portal__health-record-download',
      OPEN_AS_CCD: 'oc-patient-portal__health-record-open-as-ccd',
      OPEN_AS_PDF: 'oc-patient-portal__health-record-open-as-pdf',
      DOWNLOAD_AS_CCD: 'oc-patient-portal__health-record-download-as-ccd',
      DOWNLOAD_AS_PDF: 'oc-patient-portal__health-record-download-as-pdf',
      DOWNLOAD_AS_ZIP: 'oc-patient-portal__health-record-download-as-zip',
      SHARE_TO_CHAT: 'oc-patient-portal__health-record-share-to-chat',
      SHARE_TO_EMAIL: 'oc-patient-portal__health-record-share-to-email',
      SHARE_TO_EMAIL_INPUT:
        'oc-patient-portal__health-record-share-to-email-input',
    },
  },
  PAPERWORK: {
    ROOT: 'oc-paperwork__root',
  },
  ADDITIONAL_QUESTIONS_FORM: 'oc-additional-questions-form__root',
  PCP_QUESTIONS_WITH_EXTRA_FIELDS_FORM:
    'oc-pcp-questions-with-extra-field-form__root',
};



// WEBPACK FOOTER //
// ./src/constants/ids.js